import debounce from "../../utils/debounce";
import { CSS } from "../../constants/css";

/**
 * Component handling scrolling users back to the top of the page.
 */

const instance = ($el: Element) => {
  const checkShouldShow = () => {
    if (document.documentElement.scrollTop > window.screen.height) {
      $el.classList.add(CSS.visible);
      return;
    }

    $el.classList.remove(CSS.visible);
  };

  const scrollToTop = (e: Event) => {
    e.preventDefault();

    window.scrollTo(0, 0);

    return false;
  };

  $el.addEventListener("click", scrollToTop);

  document.addEventListener("scroll", debounce(checkShouldShow));
  checkShouldShow();
};

/**
 * Initialises each element matching the selector.
 */
const scrollTop = () => {
  const SELECTOR = ".js-scroll-top";

  document.querySelectorAll(SELECTOR).forEach(($el: Element) => {
    instance($el);
  });
};

export default scrollTop;
